<div class="custom-date-picker-wrapper fw fh">
    <div class="calendar-block fw">
        <div class="split from">
            <p-calendar class="unilever-calendar no-time-split" [(ngModel)]="customDate.from"
                [disabled]="isDisable.from" ngDefaultControl [inline]="true" [showTime]="false"
                [defaultDate]="setMinDate.min" [minDate]="startDateFrom" [maxDate]="endDate"
                (onSelect)="customDateChange()" hourFormat="24">
            </p-calendar>
        </div>
        <div class="split to" [ngClass]="{'disabled':!customDate.from}">
            <p-calendar class="unilever-calendar no-time-split" [(ngModel)]="customDate.to" ngDefaultControl
                [inline]="true" [showTime]="false" [minDate]="toCalendarMinDate" [maxDate]="maxEndDate"
                [disabled]="!customDate.from || isDisable.to" [defaultDate]="setMinDate.max"
                (onSelect)="customDateChange()" hourFormat="24"></p-calendar>
        </div>
    </div>
    <div class="button-block">
        <button mat-raised-button class="cancel spc-btn" mat-dialog-close>{{'common.cancel' | translate}}</button>
        <button mat-raised-button class="ok spc-btn" [disabled]="!selectionCorrect" (click)="applyCustomDate()"
            color="primary">{{'common.ok' | translate}}</button>
    </div>
</div>